import { HttpClient } from '../HttpClient';
/**
 * * Get List of Archived Attendance Logs via SearchCriteria
 */
export const GetArchivedAttendanceLogsSearchCriteria = async ({ Id }) => {
  try {
    const { data } = await HttpClient.get(`/api/ArchivedAttendanceLogs/SearchCriteria`, {
      params: {
        Id,
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
